import React, { useState } from 'react';
import TopBar from "../components/TopBar";
import Header from "../components/headerfooter/Header";
import Footer from "../components/headerfooter/Footer";
import CallToAction from "../components/home/CallToAction";
import { Link } from 'react-router-dom';
import { AiFillHome, AiOutlineRight, AiOutlineDown } from 'react-icons/ai';
import { FaMagic, FaMousePointer, FaExternalLinkAlt, FaDollarSign, FaBookmark } from 'react-icons/fa';

const Dashboard = () => {
  const stats = [
    { title: 'AI Tools', icon: <FaMagic />, value: 0 },
    { title: 'Total Clicks', icon: <FaMousePointer />, value: 0 },
    { title: 'Organic Clicks', icon: <FaExternalLinkAlt />, value: 0 },
    { title: 'Opens', icon: <FaMousePointer />, value: 0 },
    { title: 'Paid Clicks', icon: <FaDollarSign />, value: 0 },
    { title: 'Saves', icon: <FaBookmark />, value: 0 },
  ];

  const dropdownOptions = ["Last 7 Days", "Last 30 Days", "Last 3 Months", "Custom"];
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [selectedRange, setSelectedRange] = useState("Last 30 Days");

  const handleDropdownToggle = () => {
    setDropdownOpen(!dropdownOpen);
  };

  const handleRangeSelect = (range) => {
    setSelectedRange(range);
    setDropdownOpen(false); // Close dropdown after selection
  };

  return (
    <>
      {/* <TopBar /> */}
      <Header />
      <section className="bg-black text-white overflow-hidden my-24">
        <div className="container max-w-[80rem] mx-auto px-4 pt-5">
          <div className="mt-10 lg:mt-0 bg-black">
            <div className="mt-4">
              <nav aria-label="breadcrumb">
                <ol className="flex flex-wrap items-center gap-1.5 break-words text-sm sm:gap-2.5 text-gray-300">
                  <li className="inline-flex items-center gap-1.5 lg:text-sm xl:text-sm 2xl:text-sm text-xs capitalize">
                    <Link to="/" className="transition-colors hover:text-gray-100">
                      <AiFillHome className="h-[17px] w-[17px]" />
                    </Link>
                  </li>
                  <li className="inline-flex items-center gap-1.5">
                    <AiOutlineRight />
                  </li>
                  <li className="inline-flex items-center gap-1.5 lg:text-sm xl:text-sm 2xl:text-sm text-xs capitalize">
                    <span role="link" aria-disabled="true" aria-current="page" className="font-normal text-gray-400">
                      Dashboard
                    </span>
                  </li>
                </ol>
              </nav>
            </div>
            <div className="grid gap-4 grid-cols-12">
              <div className="col-span-full">
                <div className="my-5">
                  <div className="flex items-center mb-8 gap-3">
                    <div>
                      <div
                        className="rounded-full w-16 h-16 md:w-24 md:h-24 bg-no-repeat bg-center bg-cover bg-white flex justify-center items-center text-3xl text-black font-bold"
                        style={{ backgroundImage: "url('null')" }}
                      >
                        MO
                      </div>
                    </div>
                    <div>
                      <h1 className="text-2xl font-bold flex items-center">Moin Khan</h1>
                      <h4 className="text-xs md:text-sm lg:text-sm">@moinkhan</h4>
                      <p className="text-xs mt-2">
                        <span className="text-gray-400">Joined: January 7, 2025</span>
                      </p>
                    </div>
                  </div>
                </div>
                <div className="grid gap-4 grid-cols-2 sm:grid-cols-3 md:gap-4 lg:grid-cols-4 xl:grid-cols-6">
                  {stats.map((item, index) => (
                    <div
                      key={index}
                      className="rounded-xl bg-background-back2 text-gray-200 relative shadow-md"
                    >
                      <div className="flex flex-row items-center justify-between space-y-0 p-3 lg:p-4 pb-2 lg:pb-2">
                        <h3 className="tracking-tight text-xs lg:text-sm font-medium capitalize">{item.title}</h3>
                        <div className="h-5 w-5 text-gray-400">{item.icon}</div>
                      </div>
                      <div className="p-6 pt-0 px-3 lg:px-4 pb-3.5">
                        <div className="text-base lg:text-lg xl:text-2xl font-bold">{item.value}</div>
                      </div>
                    </div>
                  ))}
                </div>
                <div className="my-8 lg:my-12">
                  <div className="mb-3 flex justify-between items-center w-full pr-2">
                    <div className="flex items-baseline gap-4 lg:gap-8">
                      <h2 className="lg:text-xl text-lg font-semibold leading-none tracking-tight tabular-nums mt-4">My Tools</h2>
                      <Link to="#">
                        <h2 className="text-xs border border-zinc-200 dark:border-white/[0.1] rounded-xl px-3 py-2 whitespace-nowrap flex justify-center items-center gap-3">
                          Submit Another AI
                          <AiOutlineRight className="w-4 h-4" />
                        </h2>
                      </Link>
                    </div>
                    <Link className="flex justify-start items-center gap-2" to="#">
                      <span className="lg:block hidden font-medium tracking-wide w-max">View All</span>
                      <AiOutlineRight />
                    </Link>
                  </div></div>
                  
                <div className="rounded-xl bg-background-back2">
                  <div className="flex flex-col p-6 space-y-0 pb-2">
                    <div className="flex items-center justify-between">
                      <div>
                        <h3 className="lg:text-2xl text-lg font-semibold leading-none tracking-tight tabular-nums">
                          Tool Clicks
                        </h3>
                        <p className="tabular-nums">
                          <span className="font-sans lg:text-sm text-xs font-normal tracking-normal text-muted-foreground">
                            Your daily analytics tool for tracking tool clicks.
                          </span>
                        </p>
                      </div>
                      <div className="relative">
                        <button
                          type="button"
                          onClick={handleDropdownToggle}
                          className="flex h-10 items-center justify-between rounded-xl border-none outline-none bg-white/10 px-3 py-2 text-sm lg:w-[150px] w-[180px]"
                        >
                          <span>{selectedRange}</span>
                          <AiOutlineDown className="h-4 w-4 opacity-50" />
                        </button>
                        {dropdownOpen && (
                          <ul className="absolute z-10 mt-2 bg-white/10 rounded-md shadow-lg text-sm text-white">
                            {dropdownOptions.map((option, idx) => (
                              <li
                                key={idx}
                                className="px-4 py-2 hover:bg-gray-600 cursor-pointer"
                                onClick={() => handleRangeSelect(option)}
                              >
                                {option}
                              </li>
                            ))}
                          </ul>
                        )}
                      </div>
                    </div>
                  </div>
                  <div className="p-6 pt-0 px-2 sm:p-6">
                    <div className="flex justify-center text-xs min-h-[200px]">
                      <p>No Data Available</p>
                    </div>
                  </div>
                </div>

                <div className="rounded-xl bg-background-back2 mt-10">
                  <div className="flex flex-col p-6 space-y-0 pb-2">
                    <div className="flex items-center justify-between">
                      <div>
                        <h3 className="lg:text-2xl text-lg font-semibold leading-none tracking-tight tabular-nums">
                            Site Visit Clicks
                        </h3>
                        <p className="tabular-nums">
                          <span className="font-sans lg:text-sm text-xs font-normal tracking-normal text-muted-foreground">
                          Your daily analytics tool for tracking visit site clicks.
                          </span>
                        </p>
                      </div>
                      <div className="relative">
                        <button
                          type="button"
                          onClick={handleDropdownToggle}
                          className="flex h-10 items-center justify-between rounded-xl border-none outline-none bg-white/10 px-3 py-2 text-sm lg:w-[150px] w-[180px]"
                        >
                          <span>{selectedRange}</span>
                          <AiOutlineDown className="h-4 w-4 opacity-50" />
                        </button>
                        {dropdownOpen && (
                          <ul className="absolute z-10 mt-2 bg-white/10 rounded-md shadow-lg text-sm text-white">
                            {dropdownOptions.map((option, idx) => (
                              <li
                                key={idx}
                                className="px-4 py-2 hover:bg-gray-600 cursor-pointer"
                                onClick={() => handleRangeSelect(option)}
                              >
                                {option}
                              </li>
                            ))}
                          </ul>
                        )}
                      </div>
                    </div>
                  </div>
                  <div className="p-6 pt-0 px-2 sm:p-6">
                    <div className="flex justify-center text-xs min-h-[200px]">
                      <p>No Data Available</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <CallToAction />
      <Footer />
    </>
  );
};

export default Dashboard;
